import { NgClass } from '@angular/common';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { SiteDto } from '@dto';
import { GoogleService, TreeService } from '@services';
import { SiteDiagnosticsComponent } from './diagnostics/site-diagnostics.component';
import { SiteFinancialComponent } from './financial/site-financial.component';
import { SiteHomeComponent } from './home/site-home.component';

@Component({
  imports: [MatIcon, NgClass, TranslatePipe, SiteHomeComponent, SiteDiagnosticsComponent, SiteFinancialComponent],

  selector: 'monitor-ui-site',
  styleUrls: ['./site.component.scss'],
  templateUrl: './site.component.html',
})
export class SiteComponent implements OnInit, AfterViewInit, OnDestroy {
  apiKey: string;
  site: SiteDto;
  tab: 'home' | 'diagnostics' | 'financial' = 'home';

  private subscriptions: Subscription[] = [];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private listService: TreeService,
    private googleService: GoogleService,
  ) {}

  async changeTab(tab: 'home' | 'diagnostics' | 'financial'): Promise<void> {
    this.tab = tab;
    await this.router.navigate([], {
      queryParams: {
        tab: this.tab,
      },
      queryParamsHandling: 'merge',
      relativeTo: this.route,
    });
  }

  ngAfterViewInit(): void {
    this.tab = this.route.snapshot.queryParams['tab'] || 'home';
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this.route.data.subscribe(data => {
        const site: SiteDto = data['data'];
        this.listService.selectSiteInList(site);
        this.site = site;
      }),
    );
    this.apiKey = this.googleService.apiKey;
  }
}
